<template>
  <modale-form ref="form" :titolo="titoloModale" :class="coloreTitolo" @close="annulla" @salva="salva" :campi="campi" :config="config" :updateTrigger="updateTrigger"></modale-form>
</template>

<script>
/* eslint-disable */
import ModaleForm from '../ModaleForm'
import clienti from '@/services/clientiService.js'
import configurazioni from '@/services/configurazioniService.js'
import { cloneObject } from '@/components/helpers'
import _ from 'lodash'
import * as dot from 'dot-object'

export default {
  components: {
    ModaleForm
  },
  props: {
    context: Object
  },
  data() {
    return {
      clienteInModifica: null,
      campi: [],
      config: {
        disableEsciOnClick: true,
        clienteDefault: {
          recapiti: [{
            tipo: {
              codice: 'principale',
              descrizione: 'Sede'
            }
          }],
          amministrativi: {
            cliente: true,
            fornitore: false
          },
          contatti: [{
            tipo: 'titolare'
          }]
        }
      },
      updateTrigger: 1,
      clienteEsistente: false
    }
  },
  async mounted() {
    await this.refreshCliente()
  },
  computed: {
    titoloModale() {
      return this.clienteInModifica ? (this.clienteEsistente ? 'Cliente esistente: ' : 'Modifica cliente: ') + this.clienteInModifica.ragioneSociale : 'Nuovo cliente'
    },
    coloreTitolo() {
      return this.clienteEsistente ? 'red-title' : ''
    }
  },
  methods: {
    async refreshCliente() {
      const configModale = await configurazioni.getConfigurazione('display_elementi', 'elementi')
      if (configModale && configModale.clienti) {
        if (this.context.nuovoCliente && this.context.nuovoCliente.clienteInModifica) {
          const campi = configModale.clienti.modifica ? configModale.clienti.modifica.campi || [] : []
          this.config = configModale.clienti.modifica ? configModale.clienti.modifica.modale || {} : {}

          var cliente = await clienti.getCliente(this.context.nuovoCliente.clienteInModifica.codice)
          this.clienteInModifica = cliente

          // prepara dati iniziali
          for (var i = 0; i < campi.length; i++) {
            var c = campi[i]
            if (c.model) {
              var val = dot.pick(c.model, this.clienteInModifica)
              c.valore = val
            }
            if (c.campo === 'partitaIva') {
              c.onUpdateValue = this.onUpdatePartitaIva
            }
            /* if (c.campo === 'codiceFiscale') { // TODO: Verificare aggiunto ma non viene chiamato
              c.onUpdateValue = this.onUpdateCodiceFiscale
            } */
          }
          this.campi = campi
        } else {
          this.campi = configModale.clienti.nuovo ? configModale.clienti.nuovo.campi || [] : []
          this.config = configModale.clienti.nuovo ? configModale.clienti.nuovo.modale || {} : {}
          for (var ii = 0; ii < this.campi.length; ii++) {
            var cc = this.campi[ii]
            if (cc.campo === 'partitaIva') {
              cc.onUpdateValue = this.onUpdatePartitaIva
            }
            /* if (cc.campo === 'codiceFiscale') { // TODO: Verificare aggiunto ma non viene chiamato
              cc.onUpdateValue = this.onUpdateCodiceFiscale
            } */
          }
        }
      }
    },
    onKeyPress(button) {
      this.button = button
      if (!this.insertNuovoCliente && !this.modificaDatiCliente && button === '{esci}') {
        // this.seleziona()
      }
    },
    annulla() {
      // this.context.nuovoCliente = null
      this.clienteEsistente = false
      const event = {
        type: 'EDIT_CONTEXT',
        payload: {
          nuovoCliente: null
        }
      }
      this.$emit('send-event', event)
      this.$emit('close')
    },
    async salva() {
      var form = this.$refs.form
      var err = form.valida()
      if (err && err.length) {
        return
      }
      var dati = form.getDatiDotNotation()
      if (this.clienteInModifica) {
        var datiCliente = cloneObject(this.clienteInModifica)
        _.merge(datiCliente, dati)
        // console.log(datiCliente)
        const result = await clienti.modificaCliente(datiCliente)
        console.log(result)
        // // verificare se errori di creazione
        this.selezionaCliente(datiCliente)
        this.$toast('Cliente modificato con successo', { type: 'success' })
      } else { // nuovo cliente
        var codice = await this.creaCodiceCliente(dati.ragioneSociale)
        dati.codice = codice
        _.set(dati, 'fatturazione.fatturaImmediata', _.get(this.config, 'abilitaFatturazione.fatturaImmediata', false))
        _.set(dati, 'fatturazione.fatturaDifferita', _.get(this.config, 'abilitaFatturazione.fatturaDifferita', false))
        _.set(dati, 'fatturazione.scontrinoSegueFattura', _.get(this.config, 'abilitaFatturazione.scontrinoSegueFattura', false))
        const result = await clienti.creaCliente(dati)
        console.log(result)
        // verificare se errori di creazione
        this.selezionaCliente(dati)
        this.$toast('Cliente creato con successo', { type: 'success' })
        // this.context.clienteCreato = codice
      }
      var self = this
      setTimeout(() => {
        self.annulla()
      }, 200)
    },
    selezionaCliente(dati) {
      var obj = {
        codice: dati.codice,
        descrizione: dati.ragioneSociale,
        label: ' ',
        titolo: dati.codice + ' - ' + dati.ragioneSociale,
        value: ''
      }
      const event = {
        type: 'SELEZIONA_CLIENTE',
        value: obj
      }
      this.$emit('send-event', event)
      this.$store.commit('clienti/SET_CLIENTE', obj)
    },
    async creaCodiceCliente(ragSoc) {
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      const tipoNumeratore = impostazioni.clienti.tipoNumeratore
      var numeratore
      if (tipoNumeratore === '_') {
        const pattern = /[^a-zA-Z0-9-]+/gi
        numeratore = ragSoc.trim().replace(/\s\s+/g, ' ').replace(pattern, '_').toLowerCase()
      } else {
          var esistente
          do {
            numeratore = await configurazioni.getNumeratore(tipoNumeratore, true)
            esistente = await clienti.getCliente(numeratore)
          } while (esistente.message !== 'missing')      
      }
      return numeratore
    },
    async onUpdatePartitaIva(value, payload) {
      if (!payload) return
      this.context.nuovoCliente = {}
      const filtri = { testo: payload.amministrativi.partitaIva }
      const opzioni = { itemsPerPage: 10, page: 1 }
      const esistente = await clienti.getFilteredCustomers(filtri, opzioni, 'v3')
      if (Array.isArray(esistente) && esistente.rows.length > 0) {
        const cl = esistente.rows[0]
        this.context.nuovoCliente.clienteInModifica = { ...cl }
        this.clienteEsistente = true
      } else {
        var codice = await this.creaCodiceCliente(payload.ragioneSociale)
        payload.codice = codice
        _.set(payload, 'recapiti[0].tipo', {
          codice: 'principale',
          descrizione: 'Sede',
          default: true,
          univoco: true
        })
        _.set(payload, 'amministrativi.listino', {
          codice: 'L1',
          descrizione: 'Listino Base',
          ivato: true
        })
        _.set(payload, 'fatturazione.fatturaImmediata', _.get(this.config, 'abilitaFatturazione.fatturaImmediata', false))
        _.set(payload, 'fatturazione.fatturaDifferita', _.get(this.config, 'abilitaFatturazione.fatturaDifferita', false))
        _.set(payload, 'fatturazione.scontrinoSegueFattura', _.get(this.config, 'abilitaFatturazione.scontrinoSegueFattura', false))
        await clienti.creaCliente(payload)
        this.context.nuovoCliente.clienteInModifica = { ...payload }
        this.clienteEsistente = false
      }
      await this.refreshCliente()
      this.updateTrigger++
    },
    async onUpdateCodiceFiscale(value, payload) {
      if (!payload) return
      this.context.nuovoCliente = {}
      const filtri = { testo: payload.amministrativi.codiceFiscale }
      const opzioni = { itemsPerPage: 10, page: 1 }
      const esistente = await clienti.getFilteredCustomers(filtri, opzioni, 'v3')
      if (esistente.rows.length > 0) {
        const cl = esistente.rows[0]
        this.context.nuovoCliente.clienteInModifica = { ...cl }
        this.clienteEsistente = true
      } else {
        var codice = await this.creaCodiceCliente(payload.ragioneSociale)
        payload.codice = codice
        _.set(payload, 'recapiti[0].tipo', {
          codice: 'principale',
          descrizione: 'Sede',
          default: true,
          univoco: true
        })
        _.set(payload, 'amministrativi.listino', {
          codice: 'L1',
          descrizione: 'Listino Base',
          ivato: true
        })
        _.set(payload, 'fatturazione.fatturaImmediata', _.get(this.config, 'abilitaFatturazione.fatturaImmediata', false))
        _.set(payload, 'fatturazione.fatturaDifferita', _.get(this.config, 'abilitaFatturazione.fatturaDifferita', false))
        _.set(payload, 'fatturazione.scontrinoSegueFattura', _.get(this.config, 'abilitaFatturazione.scontrinoSegueFattura', false))
        await clienti.creaCliente(payload)
        this.context.nuovoCliente.clienteInModifica = { ...payload }
        this.clienteEsistente = false
      }
      await this.refreshCliente()
      this.updateTrigger++
    }
  }
}
</script>

<style lang="scss">
  .red-title .modal-title {
    color: red;
  }
</style>
